import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import FilterItem from '../FilterItem';
import { FilterItemTooltipProps, FilterOption, ItemRendererType } from '../types';

interface ItemContentProps {
  isLast: boolean;
  isSelected: boolean;
  option: FilterOption;
  onClick: (val: FilterOption) => void;
  itemRenderer?: ItemRendererType;
  isSingleSelect?: boolean;
  getTooltipProps?: FilterItemTooltipProps;
}

function ItemContent({ isLast, ...rest }: ItemContentProps) {
  return (
    <Box
      className={cn('px-8 xs:px-12', {
        'mb-8': isLast,
      })}>
      <FilterItem {...rest} />
    </Box>
  );
}

export default React.memo(ItemContent);
